<template>
<div>
    <div style="width:100%">
        <NavBar test="Login"></NavBar>
    </div>
    <v-row style="margin-top:10%" align="center" justify="center">
        <v-card width="400px" height="250px">
            <v-form ref="login" class="pa-6" lazy-validation>
                <v-text-field v-model="email" :rules="[rules.required,rules.email]" type="email" required label="Email:" dense outlined></v-text-field>

                <v-text-field v-model="pass" :rules="[rules.required,rules.pass]" type="password" required label="Password:" dense outlined></v-text-field>

                <v-row align="center" justify="center" style="margin-top:2%">
                    <v-btn class="ma-2" style="width:100px" elevation="2" depressed color="primary" @click="login">
                        Login
                    </v-btn>
                </v-row>

            </v-form>
        </v-card>

    </v-row>
</div>

</template>

<script>

import NavBar from './NavBar.vue'
export default {
    components: {
        NavBar,
    },
    created() {
        let token = this.$cookies.get("token");
        if (token != null) {
            this.$overlay.show(this);
            this.$api.verifyToken(token).then((res => {
                if (res.status == 200) {
                    token = res.data;
                    let roles = [];

                    for (let i = 0; i < token.roles.length; i++)
                        roles.push(token.roles[i].authority);

                    let path = "";
                    if (roles.includes("ADMIN")) {
                        this.$store.commit("setAdmin", true);
                        path = "/home";
                    } else if (roles.includes("IMANAGER")) {
                        this.$store.commit("setManager", true);
                        path = "/inventory/dashboard";
                    } else if (roles.includes("SCHEDULER")) {
                        this.$store.commit("setScheduler", true);
                        path = "/scheduling/calendar";
                    } else if (roles.includes("TECHNICIAN")) {
                        this.$store.commit("setTech", true);
                        path = "/inventory/dashboard";
                    } else {
                        this.$toasted.error("You account has not been approved").goAway(1200);
                        this.$overlay.hide();
                        return;
                    }

                    this.$store.commit("setToken", token);
                    this.$api.setToken(token.accessToken);
                    this.$router.push(path);
                }
                this.$overlay.hide();
            })).catch(er => {
                this.$overlay.hide();
            })
        }
    },
    data: () => ({
        email: '',
        pass: '',
        rules: {
            required: value => !!value || 'Required.',
            pass: value => {
                var re = /^\w{6,}$/;
                return re.test(value) || 'Minimum 6 letters'
            },
            email: value => {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(value) || 'Invalid Email'
            }
        },
        token: null,
    }),
    methods: {
        login() {
            if (this.$refs.login.validate()) {
                this.$overlay.show(this);
                this.$api.login(this.email, this.pass).then((res) => {
                    if (res.status == 200) {
                        this.token = res.data;
                        let roles = [];

                        for (let i = 0; i < this.token.roles.length; i++)
                            roles.push(this.token.roles[i].authority);

                        let path = "";
                        if (roles.includes("ADMIN")) {
                            this.$store.commit("setAdmin", true);
                            path = "/home";
                        } else if (roles.includes("IMANAGER")) {
                            this.$store.commit("setManager", true);
                            path = "/inventory/dashboard";
                        } else if (roles.includes("SCHEDULER")) {
                            this.$store.commit("setScheduler", true);
                            path = "/scheduling/calendar";
                        } else if (roles.includes("TECHNICIAN")) {
                            this.$store.commit("setTech", true);
                            path = "/inventory/dashboard";
                        } else {
                            this.$toasted.error("You account has not been approved").goAway(1200);
                            this.$overlay.hide();
                            return;
                        }

                        this.$store.commit("setToken", this.token);
                        this.$api.setToken(this.token.accessToken);
                        this.$cookies.set("token", this.token.accessToken);
                        this.$router.push(path);
                    }
                    this.$overlay.hide();
                }).catch(error => {
                    this.$toasted.error("Invalid Credentials").goAway(1200);
                    this.$overlay.hide();
                });

            }
        }


    }
}

</script>
